export default __webpack_public_path__ + "static/media/bootstrap.09b773cc.svg";